import React from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ChevronRightRounded } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

const SideMenuButton = ({
  to,
  children,
  startIcon = null,
  isHome,
  open,
  toggleMobileMenu,
}) => {
  const theme = useTheme();
  return (
    <ListItemButton
      key={to}
      component={RouterLink}
      to={to}
      disabled={children === "Leaderboard" ? true : false}
      onClick={() => toggleMobileMenu(false)}
      sx={{
        color: "white",
        padding: open ? "15px 24px" : "12px 15px",
        backgroundColor: "transparent",
        borderRadius: open ? "36px" : "6px",
        justifyContent: open ? "flex-start" : "center",
        "&:hover": {
          backgroundColor: theme.palette.background.brand_alt,
          color: theme.palette.text.button_hover,
          "& svg path": {
            stroke: theme.palette.text.button_hover,
          },
        },
      }}
    >
      <ListItemIcon
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minWidth: "0",
          ...(open && { marginRight: "15px" }),
          "& svg": {
            color: theme.palette.background.brand_alt,
            strokeWidth: 1.67,
            transition: "stroke 0.3s ease",
          },
        }}
      >
        {startIcon}
      </ListItemIcon>
      <ListItemText
        primary={children}
        sx={{ margin: 0 }}
        primaryTypographyProps={{
          sx: {
            margin: 0,
            display: open ? "block" : "none",
            whiteSpace: "nowrap",
            fontFamily: theme.typography.fontFamily,
            fontSize: "15px",
            fontWeight: "600",
          },
        }}
      />
      {/* {open && !isHome && (
        <ChevronRightRounded
          sx={{ color: "inherit", marginLeft: theme.customSpacing["lg"] }}
        />
      )} */}
    </ListItemButton>
  );
};

export default SideMenuButton;
